module.exports = __webpack_public_path__ + "media/images/favicon/favicon-cc3e6a0f66b648881883dfd5a4b8f85d.ico";